module.exports = __webpack_public_path__ + "static/icons/icon-snow-alert--white-410492f01913c1019bc76aaf16379b83.svg";